import { type ComponentType, PureComponent, type ReactNode } from 'react';

import classNames from 'classnames';

import Promo from './promo';

import styles from './auth.module.css';

type Props = {
  advice?: string | ReactNode;
  validationErrors?: (string | ReactNode)[];
};

export type AuthWrappedProps = {
  renderAdvice: (danger?: boolean) => ReactNode;
  renderValidationErrors: () => ReactNode;
};

function authPageWrapper<T>(
  WrappedComponent: ComponentType<T & AuthWrappedProps>,
): ComponentType<T & Props> {
  return class extends PureComponent<T & Props> {
    renderAdvice = (danger = false) => {
      if (!this.props.advice) {
        return undefined;
      }
      return (
        <div
          role={danger ? 'alert' : undefined}
          className={classNames(
            styles.alert,
            danger ? styles.danger : styles.success,
          )}
        >
          {this.props.advice}
        </div>
      );
    };

    renderValidationErrors = () => {
      if (!this.props.validationErrors) {
        return undefined;
      }
      if (this.props.validationErrors.length === 0) {
        return '';
      }
      const errors = this.props.validationErrors.map((error, i) => (
        <div key={i}>{error}</div>
      ));
      return (
        <div role="alert" className={classNames(styles.alert, styles.danger)}>
          {errors}
        </div>
      );
    };

    render() {
      return (
        <Promo>
          <div className={styles.wrapper}>
            <div className={styles.content}>
              <WrappedComponent
                {...this.props}
                renderAdvice={this.renderAdvice}
                renderValidationErrors={this.renderValidationErrors}
              />
            </div>
          </div>
        </Promo>
      );
    }
  };
}

export default authPageWrapper;
